
import { RevenueOrg } from '../RevenueOrg';

export class RevenueOrgSite extends RevenueOrg {

  constructor(props) {
    super(props, {pageForOrgType: 'SITE'})
  }
}


// WEBPACK FOOTER //
// ./src/screens/admin/sites/RevenueOrgSite.js